import { atom } from "recoil";

import { AuthorizationSet, IProfileDto } from "../../dto";

export const profileScopeAtom = atom<AuthorizationSet | undefined>({
  key: "profileScopeAtom",
  default: undefined,
});

export const profileDtoAtom = atom<IProfileDto | undefined>({
  key: "profileDtoAtom",
  default: undefined,
});

export const subdomainIsolationCompanyIdAtom = atom<number | undefined>({
  key: "subdomainIsolationCompanyIdAtom",
  default: undefined,
});
